import React from 'react';
import { PleriTaskStatus } from '../../api/tasks';
import {
  CheckCircleIcon,
  XCircleIcon,
  ExclamationTriangleIcon,
} from '@heroicons/react/24/outline';

interface TaskStatusBadgeProps {
  status: PleriTaskStatus | string;
  className?: string;
}

export const TaskStatusBadge: React.FC<TaskStatusBadgeProps> = ({
  status,
  className = '',
}) => {
  const getStatusColor = () => {
    if (status === PleriTaskStatus.Active) {
      return 'bg-green-100 dark:bg-green-900 text-green-800 border-green-200 dark:border-green-700';
    }
    if (status === PleriTaskStatus.Paused) {
      return 'bg-red-100 dark:bg-red-900 text-red-800 border-red-200 dark:border-red-700';
    }
    if (status === PleriTaskStatus.Deleted) {
      return 'bg-red-100 dark:bg-red-900 text-red-800 border-red-200 dark:border-red-700';
    }
    return 'bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-200 border-gray-200 dark:border-gray-700';
  };

  const getStatusIcon = () => {
    if (status === PleriTaskStatus.Active) {
      return <CheckCircleIcon className="h-4 w-4 text-green-600" />;
    }
    if (status === PleriTaskStatus.Paused) {
      return <ExclamationTriangleIcon className="h-4 w-4 text-amber-600" />;
    }
    if (status === PleriTaskStatus.Deleted) {
      return <XCircleIcon className="h-4 w-4 text-red-600" />;
    }
    return (
      <ExclamationTriangleIcon className="h-4 w-4 text-gray-600 dark:text-gray-400" />
    );
  };

  return (
    <div
      className={`flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium ${getStatusColor()} ${className}`}
    >
      {getStatusIcon()}
      <span className="capitalize">{status}</span>
    </div>
  );
};
